import {
  ClientType,
  OnboardingAccountsInOrganizations,
} from 'modules/onboarding/common/components';

import { useOwnerAccountsInOrganizations } from '../hooks';
import { PageComponentProps } from '../types';

export const OwnerAccountsInOrganizationsStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    onSubmit,
    goToBack,
  } = useOwnerAccountsInOrganizations();

  return (
    <OnboardingAccountsInOrganizations
      canGoBack={canGoBack}
      clientType={ClientType.Client}
      countries={countries}
      countriesLoading={countriesLoading}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
